


// import React, { useState, useEffect } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import {
//   Card,
//   Form,
//   Input,
//   Button,
//   Upload,
//   Avatar,
//   message,
//   Row,
//   Col,
//   Divider,
//   Typography,
//   Space,
//   Modal,
//   Spin
// } from "antd";
// import {
//   UserOutlined,
//   CameraOutlined,
//   SaveOutlined,
//   EditOutlined,
//   MailOutlined,
//   PhoneOutlined,
//   EnvironmentOutlined,
//   CalendarOutlined,
//   DeleteOutlined,
//   EyeOutlined,
//   LockOutlined
// } from "@ant-design/icons";
// import { updateProfile, uploadProfileImage, getProfile, updateEmail } from "../actions/auth";

// const { Title, Text } = Typography;
// const { TextArea } = Input;

// // ============ COMPOSANT UPDATE EMAIL ============
// const UpdateEmailForm = ({ currentEmail, onUpdated }) => {
//   const dispatch = useDispatch();
//   const [loading, setLoading] = useState(false);
//   const [emailForm] = Form.useForm();

//   const handleSubmit = async (values) => {
//     if (values.newEmail === currentEmail) {
//       message.warning("Le nouvel email est identique à l'actuel");
//       return;
//     }

//     setLoading(true);
//     try {
//       await dispatch(updateEmail(values.newEmail, values.password));
//       message.success("✅ Email mis à jour avec succès !");
//       emailForm.resetFields();
//       if (onUpdated) onUpdated(values.newEmail);
//     } catch (err) {
//       message.error(err.response?.data?.message || "❌ Erreur lors de la mise à jour");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Form form={emailForm} layout="vertical" onFinish={handleSubmit}>
//       <Row gutter={[20, 0]}>
//         <Col xs={24} sm={12}>
//           <Form.Item label="Email actuel">
//             <Input
//               prefix={<MailOutlined style={{ color: "#667eea" }} />}
//               value={currentEmail}
//               disabled
//               size="large"
//               style={{ borderRadius: "10px", background: "#f5f5f5" }}
//             />
//           </Form.Item>
//         </Col>

//         <Col xs={24} sm={12}>
//           <Form.Item
//             name="newEmail"
//             label="Nouvel email"
//             rules={[
//               { required: true, message: "Le nouvel email est requis" },
//               { type: "email", message: "Format email invalide" }
//             ]}
//           >
//             <Input
//               prefix={<MailOutlined style={{ color: "#667eea" }} />}
//               placeholder="nouveau@email.com"
//               size="large"
//               style={{ borderRadius: "10px" }}
//             />
//           </Form.Item>
//         </Col>
//       </Row>

//       <Row gutter={[20, 0]}>
//         <Col xs={24} sm={12}>
//           <Form.Item
//             name="password"
//             label="Mot de passe (confirmation)"
//             rules={[{ required: true, message: "Le mot de passe est requis" }]}
//           >
//             <Input.Password
//               prefix={<LockOutlined style={{ color: "#667eea" }} />}
//               placeholder="Votre mot de passe actuel"
//               size="large"
//               style={{ borderRadius: "10px" }}
//             />
//           </Form.Item>
//         </Col>
//       </Row>

//       <Form.Item style={{ marginBottom: 0 }}>
//         <Button
//           type="primary"
//           htmlType="submit"
//           size="large"
//           loading={loading}
//           icon={<SaveOutlined />}
//           style={{
//             background: "linear-gradient(45deg, #667eea, #764ba2)",
//             border: "none",
//             borderRadius: "10px",
//             height: "50px",
//             width: "200px",
//             fontSize: "16px",
//             fontWeight: "bold",
//           }}
//         >
//           Mettre à jour
//         </Button>
//       </Form.Item>
//     </Form>
//   );
// };

// // ============ COMPOSANT PRINCIPAL ============
// const ProfileManagement = () => {
//   const [form] = Form.useForm();
//   const [loading, setLoading] = useState(false);
//   const [dataLoading, setDataLoading] = useState(true);
//   const [imageUrl, setImageUrl] = useState("");
//   const [previewVisible, setPreviewVisible] = useState(false);
//   const [uploading, setUploading] = useState(false);
//   const [profileData, setProfileData] = useState(null);

//   const { user: currentUser } = useSelector((state) => state.auth);
//   const dispatch = useDispatch();

//   // Récupérer les données de profil complètes au chargement
//   useEffect(() => {
//     const fetchProfileData = async () => {
//       if (currentUser) {
//         try {
//           setDataLoading(true);
//           const response = await dispatch(getProfile());
//           setProfileData(response.payload || response);
//         } catch (error) {
//           console.error('Erreur lors de la récupération du profil:', error);
//           message.error('Erreur lors du chargement du profil');
//         } finally {
//           setDataLoading(false);
//         }
//       }
//     };
//     fetchProfileData();
//   }, [dispatch]);

//   // Remplir le formulaire avec les données
//   useEffect(() => {
//     const dataToUse = profileData || currentUser;
//     if (dataToUse && !dataLoading) {
//       form.setFieldsValue({
//         username: dataToUse.username || "",
//         email: dataToUse.email || "",
//         phone: dataToUse.phone || "",
//         location: dataToUse.location || "",
//         bio: dataToUse.bio || "",
//         birthDate: dataToUse.birthDate || dataToUse.birth_date || "",
//       });
//       const profileImage = dataToUse.profileImage || dataToUse.profile_image;
//       if (profileImage) setImageUrl(profileImage);
//     }
//   }, [profileData, currentUser, dataLoading, form]);

//   const handleImageUpload = async (file) => {
//     setUploading(true);
//     const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif';
//     if (!isJpgOrPng) {
//       message.error('Vous ne pouvez uploader que des fichiers JPG/PNG/GIF !');
//       setUploading(false);
//       return false;
//     }
//     const isLt2M = file.size / 1024 / 1024 < 2;
//     if (!isLt2M) {
//       message.error("L'image doit faire moins de 2MB !");
//       setUploading(false);
//       return false;
//     }
//     try {
//       const base64 = await getBase64(file);
//       setImageUrl(base64);
//       message.success('Image uploadée avec succès !');
//     } catch (error) {
//       message.error("Erreur lors de l'upload de l'image");
//     }
//     setUploading(false);
//     return false;
//   };

//   const getBase64 = (file) => {
//     return new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.readAsDataURL(file);
//       reader.onload = () => resolve(reader.result);
//       reader.onerror = error => reject(error);
//     });
//   };

//   const handleSubmit = async (values) => {
//     setLoading(true);
//     try {
//       const profileDataToSend = {
//         ...values,
//         profileImage: imageUrl,
//         birthDate: values.birthDate,
//         birth_date: values.birthDate,
//       };
//       await dispatch(updateProfile(profileDataToSend));
//       message.success('Profil mis à jour avec succès !');
//     } catch (error) {
//       console.error('Erreur lors de la mise à jour:', error);
//       message.error('Erreur lors de la mise à jour du profil');
//     }
//     setLoading(false);
//   };

//   const handleDeleteImage = () => {
//     Modal.confirm({
//       title: 'Supprimer la photo de profil',
//       content: 'Êtes-vous sûr de vouloir supprimer votre photo de profil ?',
//       okText: 'Supprimer',
//       cancelText: 'Annuler',
//       okType: 'danger',
//       onOk: () => {
//         setImageUrl("");
//         message.success('Photo de profil supprimée');
//       }
//     });
//   };

//   if (dataLoading) {
//     return (
//       <div style={{
//         minHeight: "100vh",
//         background: "linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center"
//       }}>
//         <Spin size="large" />
//       </div>
//     );
//   }

//   const currentEmail = profileData?.email || currentUser?.email || "";

//   return (
//     <div style={{
//       minHeight: "100vh",
//       background: "linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)",
//       padding: "40px 20px",
//     }}>
//       <div style={{ maxWidth: "1000px", margin: "0 auto" }}>

//         {/* Header */}
//         <div style={{ textAlign: "center", marginBottom: "40px" }}>
//           <Title level={1} style={{ color: "white", textShadow: "0 2px 4px rgba(0,0,0,0.3)", marginBottom: "10px" }}>
//             <EditOutlined style={{ marginRight: "15px" }} />
//             Mon Profil
//           </Title>
//           <Text style={{ color: "rgba(255,255,255,0.9)", fontSize: "18px", display: "block" }}>
//             Personnalisez votre profil et vos informations
//           </Text>
//         </div>

//         <Row gutter={[30, 30]}>

//           {/* Section Photo de profil */}
//           <Col xs={24} lg={8}>
//             <Card
//               style={{ background: "rgba(255,255,255,0.95)", borderRadius: "20px", boxShadow: "0 20px 40px rgba(0,0,0,0.1)", border: "none", height: "fit-content" }}
//               bodyStyle={{ padding: "40px", textAlign: "center" }}
//             >
//               <Title level={3} style={{ marginBottom: "30px" }}>Photo de Profil</Title>

//               <div style={{ marginBottom: "30px" }}>
//                 <Avatar
//                   size={150}
//                   src={imageUrl}
//                   icon={!imageUrl && <UserOutlined />}
//                   style={{ border: "4px solid #f0f0f0", boxShadow: "0 8px 25px rgba(0,0,0,0.1)", marginBottom: "20px" }}
//                 />
//                 {imageUrl && (
//                   <div style={{ marginTop: "15px" }}>
//                     <Space>
//                       <Button type="link" icon={<EyeOutlined />} onClick={() => setPreviewVisible(true)}>Aperçu</Button>
//                       <Button type="link" danger icon={<DeleteOutlined />} onClick={handleDeleteImage}>Supprimer</Button>
//                     </Space>
//                   </div>
//                 )}
//               </div>

//               <Upload name="avatar" listType="picture-card" showUploadList={false} beforeUpload={handleImageUpload}>
//                 <Button
//                   type="primary"
//                   icon={<CameraOutlined />}
//                   loading={uploading}
//                   style={{ background: "linear-gradient(45deg, #667eea, #764ba2)", border: "none", borderRadius: "10px", height: "45px", width: "100%" }}
//                 >
//                   {uploading ? "Upload en cours..." : "Changer la photo"}
//                 </Button>
//               </Upload>

//               <Text style={{ color: "#999", fontSize: "12px", display: "block", marginTop: "10px" }}>
//                 JPG, PNG ou GIF. Max 2MB.
//               </Text>
//             </Card>
//           </Col>

//           {/* Section Informations personnelles */}
//           <Col xs={24} lg={16}>
//             <Card
//               style={{ background: "rgba(255,255,255,0.95)", borderRadius: "20px", boxShadow: "0 20px 40px rgba(0,0,0,0.1)", border: "none" }}
//               bodyStyle={{ padding: "40px" }}
//             >
//               <Title level={3} style={{ marginBottom: "30px" }}>Informations Personnelles</Title>

//               <Form form={form} layout="vertical" onFinish={handleSubmit}>
//                 <Row gutter={[20, 0]}>
//                   <Col xs={24} sm={12}>
//                     <Form.Item name="username" label="Nom d'utilisateur"
//                       rules={[{ required: true, message: "Le nom d'utilisateur est requis" }, { min: 3, message: "Au moins 3 caractères" }]}>
//                       <Input prefix={<UserOutlined style={{ color: "#667eea" }} />} placeholder="Nom d'utilisateur" size="large" style={{ borderRadius: "10px" }} />
//                     </Form.Item>
//                   </Col>
//                   <Col xs={24} sm={12}>
//                     <Form.Item name="email" label="Adresse email (non modifiable ici)">
//                       <Input prefix={<MailOutlined style={{ color: "#667eea" }} />} size="large" disabled style={{ borderRadius: "10px", background: "#f5f5f5" }} />
//                     </Form.Item>
//                   </Col>
//                 </Row>

//                 <Row gutter={[20, 0]}>
//                   <Col xs={24} sm={12}>
//                     <Form.Item name="phone" label="Téléphone">
//                       <Input prefix={<PhoneOutlined style={{ color: "#667eea" }} />} placeholder="Numéro de téléphone" size="large" style={{ borderRadius: "10px" }} />
//                     </Form.Item>
//                   </Col>
//                   <Col xs={24} sm={12}>
//                     <Form.Item name="location" label="Localisation">
//                       <Input prefix={<EnvironmentOutlined style={{ color: "#667eea" }} />} placeholder="Ville, Pays" size="large" style={{ borderRadius: "10px" }} />
//                     </Form.Item>
//                   </Col>
//                 </Row>

//                 <Row gutter={[20, 0]}>
//                   <Col xs={24} sm={12}>
//                     <Form.Item name="birthDate" label="Date de naissance">
//                       <Input prefix={<CalendarOutlined style={{ color: "#667eea" }} />} placeholder="JJ/MM/AAAA" size="large" style={{ borderRadius: "10px" }} />
//                     </Form.Item>
//                   </Col>
//                 </Row>

//                 <Form.Item name="bio" label="Biographie">
//                   <TextArea rows={4} placeholder="Parlez-nous de vous..." style={{ borderRadius: "10px" }} maxLength={500} showCount />
//                 </Form.Item>

//                 <Divider />

//                 <Form.Item style={{ marginBottom: 0 }}>
//                   <Button
//                     type="primary" htmlType="submit" size="large" loading={loading} icon={<SaveOutlined />}
//                     style={{ background: "linear-gradient(45deg, #667eea, #764ba2)", border: "none", borderRadius: "10px", height: "50px", width: "200px", fontSize: "16px", fontWeight: "bold" }}
//                   >
//                     Sauvegarder
//                   </Button>
//                 </Form.Item>
//               </Form>
//             </Card>
//           </Col>

//           {/* ✅ Section Modifier l'email */}
//           <Col xs={24}>
//             <Card
//               style={{ background: "rgba(255,255,255,0.95)", borderRadius: "20px", boxShadow: "0 20px 40px rgba(0,0,0,0.1)", border: "none" }}
//               bodyStyle={{ padding: "40px" }}
//             >
//               <Title level={3} style={{ marginBottom: "10px" }}>
//                 <MailOutlined style={{ marginRight: "10px", color: "#667eea" }} />
//                 Modifier l'adresse email
//               </Title>
//               <Text style={{ color: "#999", display: "block", marginBottom: "30px" }}>
//                 Votre email est utilisé pour vous connecter. Une confirmation de mot de passe est requise.
//               </Text>

//               <UpdateEmailForm
//                 currentEmail={currentEmail}
//                 onUpdated={(newEmail) => {
//                   setProfileData(prev => ({ ...prev, email: newEmail }));
//                   form.setFieldsValue({ email: newEmail });
//                 }}
//               />
//             </Card>
//           </Col>

//         </Row>

//         {/* Modal aperçu photo */}
//         <Modal open={previewVisible} title="Aperçu de la photo de profil" footer={null} onCancel={() => setPreviewVisible(false)} centered>
//           <div style={{ textAlign: "center" }}>
//             <Avatar size={300} src={imageUrl} style={{ border: "4px solid #f0f0f0", boxShadow: "0 8px 25px rgba(0,0,0,0.1)" }} />
//           </div>
//         </Modal>

//       </div>
//     </div>
//   );
// };

// export default ProfileManagement;


import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Card,
  Form,
  Input,
  Button,
  Upload,
  Avatar,
  message,
  Row,
  Col,
  Divider,
  Typography,
  Space,
  Modal,
  Spin
} from "antd";
import {
  UserOutlined,
  CameraOutlined,
  SaveOutlined,
  EditOutlined,
  MailOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  CalendarOutlined,
  DeleteOutlined,
  EyeOutlined,
  LockOutlined,
  IdcardOutlined
} from "@ant-design/icons";
import { updateProfile, uploadProfileImage, getProfile, updateEmail } from "../actions/auth";

const { Title, Text } = Typography;
const { TextArea } = Input;

// ============ COMPOSANT UPDATE EMAIL ============
const UpdateEmailForm = ({ currentEmail, onUpdated }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [emailForm] = Form.useForm();

  const handleSubmit = async (values) => {
    if (values.newEmail === currentEmail) {
      message.warning("Le nouvel email est identique à l'actuel");
      return;
    }

    setLoading(true);
    try {
      await dispatch(updateEmail(values.newEmail, values.password));
      message.success("✅ Email mis à jour avec succès !");
      emailForm.resetFields();
      if (onUpdated) onUpdated(values.newEmail);
    } catch (err) {
      message.error(err.response?.data?.message || "❌ Erreur lors de la mise à jour");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form form={emailForm} layout="vertical" onFinish={handleSubmit}>
      <Row gutter={[20, 0]}>
        <Col xs={24} sm={12}>
          <Form.Item label="Email actuel">
            <Input
              prefix={<MailOutlined style={{ color: "#667eea" }} />}
              value={currentEmail}
              disabled
              size="large"
              style={{ borderRadius: "10px", background: "#f5f5f5" }}
            />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12}>
          <Form.Item
            name="newEmail"
            label="Nouvel email"
            rules={[
              { required: true, message: "Le nouvel email est requis" },
              { type: "email", message: "Format email invalide" }
            ]}
          >
            <Input
              prefix={<MailOutlined style={{ color: "#667eea" }} />}
              placeholder="nouveau@email.com"
              size="large"
              style={{ borderRadius: "10px" }}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[20, 0]}>
        <Col xs={24} sm={12}>
          <Form.Item
            name="password"
            label="Mot de passe (confirmation)"
            rules={[{ required: true, message: "Le mot de passe est requis" }]}
          >
            <Input.Password
              prefix={<LockOutlined style={{ color: "#667eea" }} />}
              placeholder="Votre mot de passe actuel"
              size="large"
              style={{ borderRadius: "10px" }}
            />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item style={{ marginBottom: 0 }}>
        <Button
          type="primary"
          htmlType="submit"
          size="large"
          loading={loading}
          icon={<SaveOutlined />}
          style={{
            background: "linear-gradient(45deg, #667eea, #764ba2)",
            border: "none",
            borderRadius: "10px",
            height: "50px",
            width: "200px",
            fontSize: "16px",
            fontWeight: "bold",
          }}
        >
          Mettre à jour
        </Button>
      </Form.Item>
    </Form>
  );
};

// ============ COMPOSANT PRINCIPAL ============
const ProfileManagement = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(true);
  const [imageUrl, setImageUrl] = useState("");
  const [previewVisible, setPreviewVisible] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [profileData, setProfileData] = useState(null);

  const { user: currentUser } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  // Récupérer les données de profil complètes au chargement
  useEffect(() => {
    const fetchProfileData = async () => {
      if (currentUser) {
        try {
          setDataLoading(true);
          const response = await dispatch(getProfile());
          setProfileData(response.payload || response);
        } catch (error) {
          console.error('Erreur lors de la récupération du profil:', error);
          message.error('Erreur lors du chargement du profil');
        } finally {
          setDataLoading(false);
        }
      }
    };
    fetchProfileData();
  }, [dispatch]);

  // Remplir le formulaire avec les données
  useEffect(() => {
    const dataToUse = profileData || currentUser;
    if (dataToUse && !dataLoading) {
      form.setFieldsValue({
        username: dataToUse.username || "",
        // ✅ NOUVEAU : fullName (avec fallback sur username si vide)
        fullName: dataToUse.fullName || dataToUse.full_name || "",
        email: dataToUse.email || "",
        phone: dataToUse.phone || "",
        location: dataToUse.location || "",
        bio: dataToUse.bio || "",
        birthDate: dataToUse.birthDate || dataToUse.birth_date || "",
      });
      const profileImage = dataToUse.profileImage || dataToUse.profile_image;
      if (profileImage) setImageUrl(profileImage);
    }
  }, [profileData, currentUser, dataLoading, form]);

  const handleImageUpload = async (file) => {
    setUploading(true);
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif';
    if (!isJpgOrPng) {
      message.error('Vous ne pouvez uploader que des fichiers JPG/PNG/GIF !');
      setUploading(false);
      return false;
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("L'image doit faire moins de 2MB !");
      setUploading(false);
      return false;
    }
    try {
      const base64 = await getBase64(file);
      setImageUrl(base64);
      message.success('Image uploadée avec succès !');
    } catch (error) {
      message.error("Erreur lors de l'upload de l'image");
    }
    setUploading(false);
    return false;
  };

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  };

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const profileDataToSend = {
        ...values,
        profileImage: imageUrl,
        birthDate: values.birthDate,
        birth_date: values.birthDate,
        // ✅ NOUVEAU : envoyer fullName (peut être vide → backend remettra username)
        fullName: values.fullName ? String(values.fullName).trim() : "",
      };
      await dispatch(updateProfile(profileDataToSend));
      message.success('Profil mis à jour avec succès !');
    } catch (error) {
      console.error('Erreur lors de la mise à jour:', error);
      message.error('Erreur lors de la mise à jour du profil');
    }
    setLoading(false);
  };

  const handleDeleteImage = () => {
    Modal.confirm({
      title: 'Supprimer la photo de profil',
      content: 'Êtes-vous sûr de vouloir supprimer votre photo de profil ?',
      okText: 'Supprimer',
      cancelText: 'Annuler',
      okType: 'danger',
      onOk: () => {
        setImageUrl("");
        message.success('Photo de profil supprimée');
      }
    });
  };

  if (dataLoading) {
    return (
      <div style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}>
        <Spin size="large" />
      </div>
    );
  }

  const currentEmail = profileData?.email || currentUser?.email || "";

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)",
      padding: "40px 20px",
    }}>
      <div style={{ maxWidth: "1000px", margin: "0 auto" }}>

        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: "40px" }}>
          <Title level={1} style={{ color: "white", textShadow: "0 2px 4px rgba(0,0,0,0.3)", marginBottom: "10px" }}>
            <EditOutlined style={{ marginRight: "15px" }} />
            Mon Profil
          </Title>
          <Text style={{ color: "rgba(255,255,255,0.9)", fontSize: "18px", display: "block" }}>
            Personnalisez votre profil et vos informations
          </Text>
        </div>

        <Row gutter={[30, 30]}>

          {/* Section Photo de profil */}
          <Col xs={24} lg={8}>
            <Card
              style={{ background: "rgba(255,255,255,0.95)", borderRadius: "20px", boxShadow: "0 20px 40px rgba(0,0,0,0.1)", border: "none", height: "fit-content" }}
              bodyStyle={{ padding: "40px", textAlign: "center" }}
            >
              <Title level={3} style={{ marginBottom: "30px" }}>Photo de Profil</Title>

              <div style={{ marginBottom: "30px" }}>
                <Avatar
                  size={150}
                  src={imageUrl}
                  icon={!imageUrl && <UserOutlined />}
                  style={{ border: "4px solid #f0f0f0", boxShadow: "0 8px 25px rgba(0,0,0,0.1)", marginBottom: "20px" }}
                />
                {imageUrl && (
                  <div style={{ marginTop: "15px" }}>
                    <Space>
                      <Button type="link" icon={<EyeOutlined />} onClick={() => setPreviewVisible(true)}>Aperçu</Button>
                      <Button type="link" danger icon={<DeleteOutlined />} onClick={handleDeleteImage}>Supprimer</Button>
                    </Space>
                  </div>
                )}
              </div>

              <Upload name="avatar" listType="picture-card" showUploadList={false} beforeUpload={handleImageUpload}>
                <Button
                  type="primary"
                  icon={<CameraOutlined />}
                  loading={uploading}
                  style={{ background: "linear-gradient(45deg, #667eea, #764ba2)", border: "none", borderRadius: "10px", height: "45px", width: "100%" }}
                >
                  {uploading ? "Upload en cours..." : "Changer la photo"}
                </Button>
              </Upload>

              <Text style={{ color: "#999", fontSize: "12px", display: "block", marginTop: "10px" }}>
                JPG, PNG ou GIF. Max 2MB.
              </Text>
            </Card>
          </Col>

          {/* Section Informations personnelles */}
          <Col xs={24} lg={16}>
            <Card
              style={{ background: "rgba(255,255,255,0.95)", borderRadius: "20px", boxShadow: "0 20px 40px rgba(0,0,0,0.1)", border: "none" }}
              bodyStyle={{ padding: "40px" }}
            >
              <Title level={3} style={{ marginBottom: "30px" }}>Informations Personnelles</Title>

              <Form form={form} layout="vertical" onFinish={handleSubmit}>
                <Row gutter={[20, 0]}>
                  <Col xs={24} sm={12}>
                    <Form.Item name="username" label="Nom d'utilisateur"
                      rules={[{ required: true, message: "Le nom d'utilisateur est requis" }, { min: 3, message: "Au moins 3 caractères" }]}>
                      <Input prefix={<UserOutlined style={{ color: "#667eea" }} />} placeholder="Nom d'utilisateur" size="large" style={{ borderRadius: "10px" }} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12}>
                    <Form.Item name="email" label="Adresse email (non modifiable ici)">
                      <Input prefix={<MailOutlined style={{ color: "#667eea" }} />} size="large" disabled style={{ borderRadius: "10px", background: "#f5f5f5" }} />
                    </Form.Item>
                  </Col>
                </Row>

                {/* ✅ NOUVEAU : Nom complet (modifiable) */}
                <Row gutter={[20, 0]}>
                  <Col xs={24}>
                    <Form.Item
                      name="fullName"
                      label={
                        <span>
                          <IdcardOutlined style={{ marginRight: 6, color: "#667eea" }} />
                          Nom complet
                          <Text type="secondary" style={{ fontSize: 11, marginLeft: 8, fontWeight: "normal" }}>
                            (utilisé pour vos certificats)
                          </Text>
                        </span>
                      }
                      rules={[
                        { max: 100, message: "Le nom complet ne peut pas dépasser 100 caractères" }
                      ]}
                      extra={
                        <Text style={{ fontSize: "11px", color: "#999", fontStyle: "italic" }}>
                          💡 Ce nom apparaîtra sur vos certificats officiels. Si laissé vide, votre nom d'utilisateur sera utilisé.
                        </Text>
                      }
                    >
                      <Input
                        prefix={<IdcardOutlined style={{ color: "#667eea" }} />}
                        placeholder="Ex: Taoufik Malaoui"
                        size="large"
                        maxLength={100}
                        showCount
                        style={{ borderRadius: "10px" }}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={[20, 0]}>
                  <Col xs={24} sm={12}>
                    <Form.Item name="phone" label="Téléphone">
                      <Input prefix={<PhoneOutlined style={{ color: "#667eea" }} />} placeholder="Numéro de téléphone" size="large" style={{ borderRadius: "10px" }} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12}>
                    <Form.Item name="location" label="Localisation">
                      <Input prefix={<EnvironmentOutlined style={{ color: "#667eea" }} />} placeholder="Ville, Pays" size="large" style={{ borderRadius: "10px" }} />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={[20, 0]}>
                  <Col xs={24} sm={12}>
                    <Form.Item name="birthDate" label="Date de naissance">
                      <Input prefix={<CalendarOutlined style={{ color: "#667eea" }} />} placeholder="JJ/MM/AAAA" size="large" style={{ borderRadius: "10px" }} />
                    </Form.Item>
                  </Col>
                </Row>

                <Form.Item name="bio" label="Biographie">
                  <TextArea rows={4} placeholder="Parlez-nous de vous..." style={{ borderRadius: "10px" }} maxLength={500} showCount />
                </Form.Item>

                <Divider />

                <Form.Item style={{ marginBottom: 0 }}>
                  <Button
                    type="primary" htmlType="submit" size="large" loading={loading} icon={<SaveOutlined />}
                    style={{ background: "linear-gradient(45deg, #667eea, #764ba2)", border: "none", borderRadius: "10px", height: "50px", width: "200px", fontSize: "16px", fontWeight: "bold" }}
                  >
                    Sauvegarder
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </Col>

          {/* ✅ Section Modifier l'email */}
          <Col xs={24}>
            <Card
              style={{ background: "rgba(255,255,255,0.95)", borderRadius: "20px", boxShadow: "0 20px 40px rgba(0,0,0,0.1)", border: "none" }}
              bodyStyle={{ padding: "40px" }}
            >
              <Title level={3} style={{ marginBottom: "10px" }}>
                <MailOutlined style={{ marginRight: "10px", color: "#667eea" }} />
                Modifier l'adresse email
              </Title>
              <Text style={{ color: "#999", display: "block", marginBottom: "30px" }}>
                Votre email est utilisé pour vous connecter. Une confirmation de mot de passe est requise.
              </Text>

              <UpdateEmailForm
                currentEmail={currentEmail}
                onUpdated={(newEmail) => {
                  setProfileData(prev => ({ ...prev, email: newEmail }));
                  form.setFieldsValue({ email: newEmail });
                }}
              />
            </Card>
          </Col>

        </Row>

        {/* Modal aperçu photo */}
        <Modal open={previewVisible} title="Aperçu de la photo de profil" footer={null} onCancel={() => setPreviewVisible(false)} centered>
          <div style={{ textAlign: "center" }}>
            <Avatar size={300} src={imageUrl} style={{ border: "4px solid #f0f0f0", boxShadow: "0 8px 25px rgba(0,0,0,0.1)" }} />
          </div>
        </Modal>

      </div>
    </div>
  );
};

export default ProfileManagement;